<template>
  <v-container>
    <OccurrenceExportData></OccurrenceExportData>
    <v-row justify="center">
      <v-col cols="12" sm="1" md="4" lg="4">
        <v-card class="pa-2" outlined tile>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="headline"
                >Buceos Registrados</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>
          <v-card-text>
            <v-row align="center">
              <v-col class="display-3">
                {{ dataIndicators.eventTotal || 0 }}
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="1" md="4" lg="4">
        <v-card class="pa-2" outlined tile>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="headline"
                >Usuarios Registrados</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>
          <v-card-text>
            <v-row align="center">
              <v-col class="display-3">
                {{ dataIndicators.practitionerTotal || 0 }}
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="1" md="4" lg="4">
        <v-card class="pa-2" outlined tile>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="headline"
                >Especies Registradas</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>
          <v-card-text>
            <v-row align="center">
              <v-col class="display-3">
                {{ dataIndicators.organismTotal || 0 }}
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12" sm="1" md="6" lg="6">
        <v-card class="pa-2" outlined tile>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="headline"
                >Buceos Ingresados</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>
          <apexchart
            type="line"
            :options="chartOptionsBuceos"
            :series="seriesBuceos"
          ></apexchart>
        </v-card>
      </v-col>
      <v-col cols="12" sm="1" md="6" lg="6">
        <v-card class="pa-2" outlined tile>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="headline"
                >Frecuencia Especies</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>
          <apexchart
            type="bar"
            height="398px"
            :options="chartOptionsOrganismFrecuency"
            :series="seriesOrganismFrecuency"
          ></apexchart>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12">
        <v-card class="pa-6" outlined tile>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="headline"
                >Top 10 Usuarios más activos (buceos y especies
                identificadas)</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>
          <apexchart
            type="bar"
            height="350"
            :options="chartOptionsUsers"
            :series="seriesUsersMostActive"
          ></apexchart>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import OccurrenceExportData from "../Occurrence/OccurrenceExportData";
export default {
  components: {
    OccurrenceExportData
  },
  data: function() {
    return {
      seriesBuceos: [],
      chartOptionsBuceos: {
        chart: {
          height: 350,
          type: "line"
        },
        stroke: {
          width: 7,
          curve: "smooth"
        },
        xaxis: {
          type: "datetime"
        },
        yaxis: {
          min: 0
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "dark",
            gradientToColors: ["#FDD835"],
            shadeIntensity: 1,
            type: "horizontal",
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 100, 100, 100]
          }
        },
        tooltip: {
          theme: "dark"
        },
        markers: {
          size: 4,
          colors: ["#FFA41B"],
          strokeColors: "#fff",
          strokeWidth: 2,
          hover: {
            size: 7
          }
        }
      },
      seriesOrganismFrecuency: [],
      chartOptionsOrganismFrecuency: {
        chart: {
          type: "bar",
          height: 380
        },
        plotOptions: {
          bar: {
            barHeight: "100%",
            distributed: true,
            horizontal: true,
            dataLabels: {
              position: "bottom"
            }
          }
        },
        dataLabels: {
          enabled: true,
          textAnchor: "start",
          style: {
            fontSize: "12px",
            colors: ["#fff"]
          },
          formatter: function(val, opt) {
            return (
              opt.w.globals.labels[opt.dataPointIndex] +
              ":  " +
              parseFloat(val).toFixed(2) +
              "%"
            );
          },
          offsetX: -35,
          dropShadow: {
            enabled: true
          }
        },
        stroke: {
          width: 1,
          colors: ["#fff"]
        },
        xaxis: {
          type: "category"
        },
        yaxis: {
          labels: {
            show: false
          }
        },
        tooltip: {
          theme: "dark",
          x: {
            show: false
          },
          y: {
            title: {
              formatter: function() {
                return "%";
              }
            }
          }
        }
      },
      seriesUsersMostActive: [],
      chartOptionsUsers: {
        chart: {
          id: "chartespecies",
          height: 350,
          type: "bar"
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "25%",
            distributed: true
          }
        },
        dataLabels: {
          enabled: true
        },
        legend: {
          show: false
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"]
        },
        yaxis: {
          labels: {
            formatter: function(val, index) {
              return parseInt(val);
            }
          }
        },
        xaxis: {
          type: "category",
          labels: {
            style: {
              fontSize: "12px"
            }
          }
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          theme: "dark"
        }
      },
      dataIndicators: {}
    };
  },
  methods: {
    async getList() {
      try {
        let { data: dataIndicators } = await this.$http.get(
          "home/get-indicators"
        );
        this.dataIndicators = dataIndicators;
      } catch (err) {
        this.dataIndicators = {};
      }
    },
    async getOrganismFrequency() {
      try {
        let { data: orgFrecuency } = await this.$http.get(
          "organism/organism-frecuency"
        );
        this.seriesOrganismFrecuency = [
          { name: "Especie", data: orgFrecuency }
        ];
      } catch (err) {
        console.log(err);
        throw err;
      }
    },

    async getMostActiveUsers() {
      try {
        let { data: mostActive } = await this.$http.get(
          "practitioner/quantity-organisms"
        );
        this.seriesUsersMostActive = [
          { name: "Buceos realizados", data: mostActive.divers },
          { name: "Especies vistas", data: mostActive.countOrganism }
        ];
      } catch (err) {
        console.log(err);
        throw err;
      }
    },

    async getDive() {
      try {
        let { data: cDives } = await this.$http.get("event/dive");
        let arrDive = [];
        cDives.map(e => {
          arrDive.push([e._id, e.count]);
        });
        this.seriesBuceos = [{ name: "Buceos", data: arrDive }];
      } catch (err) {
        console.log(err);
        throw err;
      }
    }
  },
  mounted: function() {
    this.getList();
    this.getDive();
    this.getOrganismFrequency();
    this.getMostActiveUsers();
  }
};
</script>

<style></style>
